import { useEffect, useRef } from 'react'

export function useModal(onClose: () => void) {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const previous = document.activeElement as HTMLElement | null
    const node = ref.current

    const focusable = node?.querySelector<HTMLElement>(
      '[autofocus], input, select, textarea, button:not([aria-label="Close"])',
    )

    ;(focusable ?? node)?.focus()

    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()

      if (e.key === 'Tab' && node) {
        const items = [
          ...node.querySelectorAll<HTMLElement>(
            'a[href], button:not(:disabled), input:not(:disabled), select, textarea, [tabindex="0"]',
          ),
        ]

        if (!items.length) return
        const first = items[0]
        const last = items[items.length - 1]

        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault()
          last.focus()
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault()
          first.focus()
        }
      }
    }

    document.addEventListener('keydown', onKey)
    document.body.style.overflow = 'hidden'

    return () => {
      document.removeEventListener('keydown', onKey)
      document.body.style.overflow = ''
      previous?.focus?.()
    }
  }, [onClose])

  return ref
}
